import { MatchParams as WorkspaceTeamsMatchParams } from '@/pages/WorkspaceTeams/types';

enum WorkspaceSections {
  Models = 'models',
  ModelAPIs = 'model-apis',
  Chains = 'chains',
  Training = 'training',
  Overview = 'overview',
}

type MatchParams = WorkspaceTeamsMatchParams;

export { WorkspaceSections, MatchParams };
